export default __webpack_public_path__ + "static/media/20t.1500986f.jpg";